export default "__VITE_ASSET__CZBo0ooh__"